import { Component, Vue, PropSync, Prop, Watch } from 'vue-property-decorator';
import type { ScrapAgentRegisterRequest } from '@/shared/model/scrap-agent.model';

@Component
export default class ScrapStep extends Vue {
  @PropSync('formData', { type: Object })
  formDataStep1!: ScrapAgentRegisterRequest;

  @Prop({ type: Array, default: () => [] })
  listAgent!: string[];

  isDuplicate = false;

  @Watch('formDataStep1.briefingTitle', { deep: true, immediate: true })
  onCheckDuplicate(value: any) {
    console.log(value, 'value');
    if (value && this.listAgent.includes(value)) {
      this.isDuplicate = true;
    } else {
      this.isDuplicate = false;
    }
  }
}
